import React from 'react'
import { useTable } from '../../Components/useTable';



const Products = () => {
const type="Products"
    const headCells = [
        { id: "name", numeric: false, label: "Name" },
        { id: "ProductCategory", numeric: false, label: "Category" },
        { id: "entranceEffectType", numeric: false, label: "Enterance Effect" },
        { id: "picture", numeric: false, label: "Picture" },
        { id: "animationsurl", numeric: false, label: "Animation" },
        { id: "created", numeric: false, label: "Created at" },
        { id: "action", numeric: false, label: "Action" },
      ];
   
      const { tableUI } = useTable({
        headCells,
        type
      });
  return (

<div className='admin-body'>
      <div className="table-area">{tableUI}</div>
    </div>
    
  )
}

export default Products